import HttpService from '../../services/HttpService';
import ErrorSwitchCase from '../../services/ErrorHandlerService';
import { ADMIN_PATH } from '../../url';
const _axios = HttpService.getAxiosClient();

export const validateBulkUploadCsv = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await _axios.post(`${ADMIN_PATH}/bulk-upload/validate`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const submitBulkUploadCsv = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await _axios.post(`${ADMIN_PATH}/bulk-upload/submit`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};
